import useFetch from '@hooks/useFetch';
import { emptyList } from '@constants/empty';

const useCountries = () => {
  const { data: countries } = useFetch('v2/internationalization/countries/');
  return countries || emptyList;
};

export default useCountries;
